/**
 *  2022-07 活动
 *  通用活动界面, 各产品app内部展示及微信分享h5展示
 */

 import React, { useEffect, useState, useRef } from 'react';
 import { useLocation } from "react-router-dom";
 import { Toast } from 'antd-mobile';
 import { isIos, isAndroid, inWeixin } from 'web-launch-app';
 import './index.scss';
 import { getParameter } from "../../utils/func";
 import WxAuthor from '../../components/wxAuthor/index'
 import DoubleShareActivity from "../../services/DoubleShareActivity.js";
 let playbills = null;
 let playbill_share = null;
 
 const DbclockShareActivity = () => {
     const location = useLocation();
     const app = navigator.userAgent;
     const appId = 'wx754e1b2a81936e91';
     const pageState = localStorage.getItem("pageState");
     const [wxAllData, setWxAllData] = useState({}); // 微信授权的信息
     const [allData, setAllData] = useState({});
     const [shareNickName, setShareNickName] = useState('');
     const [shareTitle, setShareTitle] = useState('');
     const [isJoin, setIsJoin] = useState(false);
     const [isDownload, setIsDownload] = useState(false);
 
     useEffect(() => {
         document.title = '双环时钟';
         document.querySelector('meta[name="description"]').setAttribute('content', '成为凯如斯合伙人，享30%返佣收益');
         window.payStatus = payStatus;
         document.body.style.background = '#FFFFFF';
         getProductPrice();
         localStorage.removeItem("pageState");
         if (app.indexOf("-device(iOS)") > -1 || app.indexOf("-device(andriod)") > -1) {
            window.appSdk.changeStatusBar && window.appSdk.changeStatusBar(false);
         }
     }, []);
 
     const getProductPrice = () => {
        const token = getParameter("token", location.search);
        console.log('share_token,,,', token)
        console.log('inWeixin,,,', inWeixin);

        if (inWeixin) { // 部署时需要去掉 ！
            const code = getParameter("code");
            console.log('code,,,,', code);
            if (code == null || code === "") {
                toWxpayAuth()
            }
            if (code) {
                const token = getParameter("token", location.search);
                const from_product = getParameter("from_product", location.search) || 'dbclock';
                DoubleShareActivity.checkUserByWxcode({ code: code, from_product: from_product }).then(resq => {
                    const data = resq.data ? resq.data : {};
                    setWxAllData({ ...data });
                    let uid = data.u_id;
                    if (data.u_id == '-1') {
                        uid = '0';
                        setIsDownload(true);
                        return;
                    }
                    if (data.u_id == '0') {
                        setIsDownload(true);
                        return;
                    }

                    DoubleShareActivity.getDbclockShare({ token: token, u_id: uid }).then(res => {
                        if (res.data) {
                            setShareNickName(res.data.nickname);
                            setShareTitle(res.data.title);
                            setIsJoin(res.data.is_join==1 ? true : false);
                        }
                    }).catch(error => {
                        if (error.message) {
                            Toast.info(error.message)
                        }
                    })
                }).catch(error => {
                    Toast.hide();
                    if (error.message) {
                        if ((typeof(error.message) == 'string') && (error.message.indexOf('未能取得授权') != '-1')) {
                            toWxpayAuth();
                        } else {
                            Toast.info(error.message);
                        }
                    }
                })
            }
        } else if(isInApp()) { // 这是App
            DoubleShareActivity.getDbclockShare({ token: token }).then(res => {
                if (res.data) {
                    setShareNickName(res.data.nickname);
                    setShareTitle(res.data.title);
                }
            }).catch(error => {
                if (error.message) {
                    Toast.info(error.message)
                }
            })
        } else {
            toWxpayAuth();
            // return;
            // DoubleShareActivity.getDbclockShare({ token: token, u_id: '79922' }).then(res => {
            //     if (res.data) {
            //         setShareNickName(res.data.nickname);
            //         setShareTitle(res.data.title);
            //     }
            // }).catch(error => {
            //     if (error.message) {
            //         Toast.info(error.message)
            //     }
            // })
        }
     }
 
    const toWxpayAuth = () => {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/dbclock/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        // forcePopup=true&
        // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/dbclock/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };

    const close = () => {
        window.location.href = "re-close://";
    };

    // 重新刷新当前页面
    const refreshLocation = () => {
        const token = getParameter("share_token", location.search);
        const from_product = getParameter("from_product", location.search) || 'dbclock';
        const nickname = getParameter("nickname", location.search);
        const title = getParameter("title", location.search);
        window.location.replace("http://todo.kairusi.cn/web/dbclock/#/dbclock-share-activity?share_token=" + token + "&from_product=" + from_product + "&nickname=" + nickname + "&title=" + title);
    };
 
     const share = () => {  
         const token = getParameter("share_token", location.search);
         const from_product = getParameter("from_product", location.search) || 'dbclock';
         const nickname = getParameter("nickname", location.search);
         const title = getParameter("title", location.search);
         const data = {
             title: `${nickname}给你共享了一份双环时钟“${title}”`,
             des: '点击立即加入你的时钟列表',
             imgUrl: 'https://kairusi.oss-cn-hangzhou.aliyuncs.com/manage/dbclock.png',
             linkUrl: window.location.protocol + "//" + window.location.host + "/web/dbclock/#/dbclock-share-activity?share_token=" + token + "&from_product=" + from_product + "&nickname=" + nickname + "&title=" + title
         };
         window.appSdk.share && window.appSdk.share(data.title, data.des, data.imgUrl, data.linkUrl);
         window.appSdk.shareToWx && window.appSdk.shareToWx(data.title, data.des, data.imgUrl, data.linkUrl, JSON.stringify(playbills || []), playbill_share);
     };
 
     const payStatus = (obj) => {
         if (obj.status === '1') {
             //支付成功
         } else if (obj.status === '2') {
             //支付取消
         } else if (obj.status === '3') {
             //支付失败
         }
     };

    const isInApp = () => app.indexOf("-device(iOS)") > -1 || app.indexOf("-device(andriod)") > -1 || app.indexOf("-device(iPad)") > -1

    const handleAdd = () => {
        console.log('加入:::');
        console.log('wxAllData:::', wxAllData);
        const token = getParameter("token", location.search);
        DoubleShareActivity.addDbclock({ token, u_id: wxAllData.u_id }).then(res => {
            if (res.res == 200) {
                Toast.info('加入成功！');
                setIsJoin(true);
            } else {
                Toast.info(res.msg);
            }
        }).catch(error => {
            if (error.message) {
                Toast.info(error.message);
            }
        })
    }
    const openApp = () => {
        if (isIos) {
            window.location.replace("https://apps.apple.com/cn/app/id1599638541");
        } else if (isAndroid) {
            if (inWeixin) {
                window.location.replace("https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.doublecircleclock");
            }
        } else {
            window.location.href = "https://www.kairusi.com/html/product.html";
        }
    };
    // 未注册用户 立即体验
    const handleNow = () => {
        console.log('wxAllData::::', wxAllData);
        const token = getParameter("share_token", location.search);
        const from_product = getParameter("from_product", location.search);
        DoubleShareActivity.shareWxInite({
            share_token: token,
            from_product: from_product,
            union_id: wxAllData.wx_unionid,
            nickname: wxAllData.wx_nickname,
        }).then(res => {
            openApp();
        }).catch(error => error.message && Toast.info(error.message))
    }

     return (<> { (wxAllData && wxAllData.is_snapshotuser == 1) ?
        <WxAuthor logo={
            require('../../image/download-logo.png').default
        }/>: (!isDownload) ? <div className="dbclick-page" style={{overflowX: 'hidden', overflowY: 'scroll'}}>
     <div>
         {isInApp() &&
             <div className="navi">
                 <img className="close" src={require("../../image/back-arrow.png").default} onClick={close} />
                 <div className="may-title" style={{color: '#fff'}}>双环时钟</div>
                 <img className="share" src={require("../../image/share.png").default} onClick={share} />
         </div>}
         <div className='page-container-db'>
             <div className='dbclick-share-box'>
                 <img className="dbclick-share-img" src={require("../../image/dbclick-share.png").default} />
             </div>
             <div className='dbclick-desc-box'>
                 <span className='dbcilck-desc-style'>{shareNickName}</span>
                 <span>给你共享了一份双环时钟</span>
                 <span className='dbcilck-desc-style'>{shareTitle}</span>
             </div>
             {isJoin ? <div className='dbclick-btn-two'>加入成功</div> : <div className='dbclick-btn' onClick={() => {handleAdd()}}>加入</div>}
         </div>
     </div>
 </div>: <div className="download-page">
            <img src={require("../../image/download-bg.png").default} alt="" className="download-bg" />
            <div className="download-header">
                <img src={require("../../image/download-logo.png").default} alt="" className="download-icon" />
                <img src={require("../../image/download-tips.png").default} alt="" className="download-tips" />
                <img src={require("../../image/dowload-mark.png").default} alt="" className="download-mark" />
            </div>
            <div className="download-btn" onClick={() => handleNow()}>立即体验</div>
        </div>}
        
    </>)
 }
 
 export default DbclockShareActivity;